import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const BackButton = ({ to = -1, label = "Back", className = "" }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`custom-back-btn ${className}`}
    >
      <span className="icon">
        <FiArrowLeft size={18} />
      </span>
      <span>{label}</span>
    </button>
  );
};

export default BackButton;